import {
  PostTypeFacebookReel,
  PostTypeFacebookStory,
} from '~publish/legacy/post/constants'

import { Empty } from '../Common/Empty'
import type { PostType, FacebookDraft, ProfilePreview } from '../types'
import { FacebookPost } from './components/Post'
import { Reel } from './components/Reel'
import { PostPreviewCard } from '../Common/styles'
import { Story } from './components/Story/index'

import styles from './FacebookPreview.module.css'

import type { JSX } from 'react'

const Content = ({
  draftFacebook,
  profile,
  updateType,
}: {
  draftFacebook: PostType
  profile: ProfilePreview
  updateType: string | null
}): JSX.Element => {
  switch (updateType) {
    case PostTypeFacebookReel:
      return <Reel content={draftFacebook.content} profile={profile} />
    case PostTypeFacebookStory:
      return <Story content={draftFacebook.content} profile={profile} />
    default:
      return <FacebookPost content={draftFacebook.content} profile={profile} />
  }
}

export const FacebookPreview = ({
  draft,
  profile,
}: {
  draft: FacebookDraft
  profile: ProfilePreview
}): JSX.Element => {
  if (draft.isEmpty) return <Empty />

  const draftFacebook: PostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  return (
    <PostPreviewCard
      data-testid="facebook-preview"
      className={styles.facebookPreview}
    >
      <Content
        draftFacebook={draftFacebook}
        profile={profile}
        updateType={draft.updateType}
      />
    </PostPreviewCard>
  )
}
